import colors from '@monorepo-zazuu/shared/constants/colors';
import AppointmentStatusEnum from './enums/AppointmentStatusEnum';

// Status que tiram o agendamento da operação: não podem ser alocados em rota
// (profissional + horário). A API recusa a alocação com as mesmas mensagens
// abaixo; aqui o admin só antecipa o bloqueio e mostra o motivo no card.
export const OFF_AGENDA_APPOINTMENT_STATUSES: number[] = [
  AppointmentStatusEnum['Concluído sem atendimento'],
  AppointmentStatusEnum['Em análise de cancelamento'],
  AppointmentStatusEnum.Cancelado,
];

interface IOffAgendaAppointmentInfo {
  label: string;
  color: string;
  textColor: string;
  message: string;
}

export const OFF_AGENDA_APPOINTMENT_INFO: Record<number, IOffAgendaAppointmentInfo> = {
  [AppointmentStatusEnum['Em análise de cancelamento']]: {
    label: 'Em análise de cancelamento',
    color: colors.suport.alert,
    textColor: colors.gray.white,
    message: 'Agendamento em análise de cancelamento: resolva o pedido de reembolso antes de alocar.',
  },
  [AppointmentStatusEnum['Concluído sem atendimento']]: {
    label: 'Concluído sem atendimento',
    color: colors.gray.dark01,
    textColor: colors.gray.white,
    message: 'Agendamento concluído sem atendimento: não pode ser alocado em rota.',
  },
  // O modal de alocação não lista cancelados (busca com statusNotEqual: -1); a entrada
  // fica para manter as mensagens iguais às da API (usadas no catch do GeneratorRoutes).
  [AppointmentStatusEnum.Cancelado]: {
    label: 'Cancelado',
    color: colors.gray.dark03,
    textColor: colors.gray.dark01,
    message: 'Agendamento cancelado: não pode ser alocado em rota.',
  },
};

export const isOffAgendaAppointment = (status: number | undefined | null): boolean =>
  typeof status === 'number' && OFF_AGENDA_APPOINTMENT_STATUSES.includes(status);

export const getOffAgendaAppointmentInfo = (
  status: number | undefined | null,
): IOffAgendaAppointmentInfo | undefined =>
  isOffAgendaAppointment(status) ? OFF_AGENDA_APPOINTMENT_INFO[status as number] : undefined;
